import { HexColor } from './palette/colors';

export const unityColorTokens = {
  '--color-brand-50': '#ebfef5',
  '--color-brand-100': '#dcfeed',
  '--color-brand-200': '#b4fdd8',
  '--color-brand-300': '#9cfccb',
  '--color-brand-400': '#83fcbf',
  '--color-brand-500': '#6afbb2',
  '--color-brand-600': '#4dffa6',
  '--color-brand-700': '#06e073',
  '--color-brand-800': '#04954d',
  '--color-brand-900': '#036333',
  '--color-brand-950': '#02311a',
  '--color-brand-1000': '#001f0f',
  '--color-red-50': '#fff5f6',
  '--color-red-100': '#ffdbe2',
  '--color-red-200': '#f8bec9',
  '--color-red-300': '#f5a3b1',
  '--color-red-400': '#fe8191',
  '--color-red-500': '#ff5271',
  '--color-red-600': '#ff3459',
  '--color-red-700': '#ff002e',
  '--color-red-800': '#cc0025',
  '--color-red-900': '#a6001e',
  '--color-red-950': '#410611',
  '--color-red-1000': '#310213',
  '--color-orange-50': '#fff6e6',
  '--color-orange-100': '#fff0d1',
  '--color-orange-200': '#ffe2a8',
  '--color-orange-300': '#ffd580',
  '--color-orange-400': '#ffc95c',
  '--color-orange-500': '#ffc042',
  '--color-orange-600': '#fead20',
  '--color-orange-700': '#e59900',
  '--color-orange-800': '#b27700',
  '--color-orange-900': '#805500',
  '--color-orange-950': '#4d3300',
  '--color-orange-1000': '#190d01',
  '--color-green-50': '#edfcf6',
  '--color-green-100': '#c5f6e2',
  '--color-green-200': '#a6efd3',
  '--color-green-300': '#84e9c4',
  '--color-green-400': '#5be1b5',
  '--color-green-500': '#26cf9f',
  '--color-green-600': '#16a17b',
  '--color-green-700': '#0e8a68',
  '--color-green-800': '#02724f',
  '--color-green-900': '#1e5743',
  '--color-green-950': '#182520',
  '--color-green-1000': '#011817',
  '--color-malibu-50': '#fbfcfe',
  '--color-malibu-100': '#f7f9fd',
  '--color-malibu-200': '#f3f6fc',
  '--color-malibu-300': '#e2eaf8',
  '--color-malibu-400': '#adc3eb',
  '--color-malibu-500': '#6c91da',
  '--color-malibu-600': '#4775d1',
  '--color-malibu-700': '#172d4f',
  '--color-malibu-800': '#142643',
  '--color-malibu-900': '#101f37',
  '--color-malibu-950': '#0b1525',
  '--color-malibu-1000': '#000a19',
  '--color-charcoal-50': '#eef3fc',
  '--color-charcoal-100': '#e5eefa',
  '--color-charcoal-200': '#d4e2f7',
  '--color-charcoal-300': '#b3c7e5',
  '--color-charcoal-400': '#8798b2',
  '--color-charcoal-500': '#5e6e88',
  '--color-charcoal-600': '#3d4d66',
  '--color-charcoal-700': '#344156',
  '--color-charcoal-800': '#303c50',
  '--color-charcoal-900': '#1f2938',
  '--color-charcoal-950': '#172130',
  '--color-charcoal-1000': '#181b25',
  '--color-purple-50': '#f1f0fe',
  '--color-purple-100': '#dbd8fd',
  '--color-purple-200': '#c4bffc',
  '--color-purple-300': '#aea7fb',
  '--color-purple-400': '#9c93fb',
  '--color-purple-500': '#8a80fa',
  '--color-purple-600': '#5e53de',
  '--color-purple-700': '#4b3eda',
  '--color-purple-800': '#3729d6',
  '--color-purple-900': '#2c21ab',
  '--color-purple-950': '#211980',
  '--color-purple-1000': '#161056',
  '--color-blue-50': '#e5f6ff',
  '--color-blue-100': '#ccedff',
  '--color-blue-200': '#a8e0ff',
  '--color-blue-300': '#8fd7ff',
  '--color-blue-400': '#66c8ff',
  '--color-blue-500': '#29b2ff',
  '--color-blue-600': '#0272b1',
  '--color-blue-700': '#025888',
  '--color-blue-800': '#004e7a',
  '--color-blue-900': '#003a5c',
  '--color-blue-950': '#002033',
  '--color-blue-1000': '#000d14',
  '--color-accent-palatinate-blue-50': '#e7ecfd',
  '--color-accent-palatinate-blue-100': '#d0d8fb',
  '--color-accent-palatinate-blue-200': '#a9b9fc',
  '--color-accent-palatinate-blue-300': '#7f98fa',
  '--color-accent-palatinate-blue-400': '#5576fa',
  '--color-accent-palatinate-blue-500': '#4064f5',
  '--color-accent-palatinate-blue-600': '#1d47f0',
  '--color-accent-palatinate-blue-700': '#0e2eaf',
  '--color-accent-palatinate-blue-800': '#0b268f',
  '--color-accent-palatinate-blue-900': '#081b68',
  '--color-accent-palatinate-blue-950': '#050c39',
  '--color-accent-palatinate-blue-1000': '#020618',
  '--color-accent-sushi-green-50': '#f1faeb',
  '--color-accent-sushi-green-100': '#e4f5d6',
  '--color-accent-sushi-green-200': '#d6f0c2',
  '--color-accent-sushi-green-300': '#bbe599',
  '--color-accent-sushi-green-400': '#a0db70',
  '--color-accent-sushi-green-500': '#85d147',
  '--color-accent-sushi-green-600': '#5b9c27',
  '--color-accent-sushi-green-700': '#487a1f',
  '--color-accent-sushi-green-800': '#345a16',
  '--color-accent-sushi-green-900': '#2b4912',
  '--color-accent-sushi-green-950': '#1d310c',
  '--color-accent-sushi-green-1000': '#0c1405',
  '--color-accent-royal-fuchsia-50': '#faebf4',
  '--color-accent-royal-fuchsia-100': '#f4d7ea',
  '--color-accent-royal-fuchsia-200': '#efc3df',
  '--color-accent-royal-fuchsia-300': '#e49bca',
  '--color-accent-royal-fuchsia-400': '#d964b0',
  '--color-accent-royal-fuchsia-500': '#ce4ba0',
  '--color-accent-royal-fuchsia-600': '#c33591',
  '--color-accent-royal-fuchsia-700': '#a02c77',
  '--color-accent-royal-fuchsia-800': '#842462',
  '--color-accent-royal-fuchsia-900': '#641b4b',
  '--color-accent-royal-fuchsia-950': '#3c102d',
  '--color-accent-royal-fuchsia-1000': '#14050f',
  '--color-accent-turquoise-50': '#f0fffe',
  '--color-accent-turquoise-100': '#d9fffd',
  '--color-accent-turquoise-200': '#bbfaf7',
  '--color-accent-turquoise-300': '#89faf4',
  '--color-accent-turquoise-400': '#15ede2',
  '--color-accent-turquoise-500': '#0cc9c0',
  '--color-accent-turquoise-600': '#089e96',
  '--color-accent-turquoise-700': '#00857e',
  '--color-accent-turquoise-800': '#006e68',
  '--color-accent-turquoise-900': '#004e52',
  '--color-accent-turquoise-950': '#003945',
  '--color-accent-turquoise-1000': '#00191f',
  '--color-accent-olive-50': '#fdfbe7',
  '--color-accent-olive-100': '#fbf8d0',
  '--color-accent-olive-200': '#f8f0a0',
  '--color-accent-olive-300': '#f4e971',
  '--color-accent-olive-400': '#e3d212',
  '--color-accent-olive-500': '#c7b70f',
  '--color-accent-olive-600': '#a1920c',
  '--color-accent-olive-700': '#686008',
  '--color-accent-olive-800': '#554f07',
  '--color-accent-olive-900': '#3e3905',
  '--color-accent-olive-950': '#2b2703',
  '--color-accent-olive-1000': '#131101',
  '--color-accent-vodka-50': '#efe9fc',
  '--color-accent-vodka-100': '#dfd3f8',
  '--color-accent-vodka-200': '#cebdf4',
  '--color-accent-vodka-300': '#bea7f1',
  '--color-accent-vodka-400': '#ae91ee',
  '--color-accent-vodka-500': '#8e65e7',
  '--color-accent-vodka-600': '#6e39e0',
  '--color-accent-vodka-700': '#541fc6',
  '--color-accent-vodka-800': '#41189a',
  '--color-accent-vodka-900': '#2f116e',
  '--color-accent-vodka-950': '#160835',
  '--color-accent-vodka-1000': '#090316',
  '--color-accent-orchid-50': '#f6e7fe',
  '--color-accent-orchid-100': '#edcffc',
  '--color-accent-orchid-200': '#e4b6fb',
  '--color-accent-orchid-300': '#db9efa',
  '--color-accent-orchid-400': '#ce7cf7',
  '--color-accent-orchid-500': '#c44dff',
  '--color-accent-orchid-600': '#a60df2',
  '--color-accent-orchid-700': '#850ac2',
  '--color-accent-orchid-800': '#640891',
  '--color-accent-orchid-900': '#530679',
  '--color-accent-orchid-950': '#28033a',
  '--color-accent-orchid-1000': '#110118',
  '--color-accent-raspberry-50': '#fde7ef',
  '--color-accent-raspberry-100': '#fdcedf',
  '--color-accent-raspberry-200': '#fbb6ce',
  '--color-accent-raspberry-300': '#fa9ebe',
  '--color-accent-raspberry-400': '#f76e9d',
  '--color-accent-raspberry-500': '#f53d7d',
  '--color-accent-raspberry-600': '#e90c59',
  '--color-accent-raspberry-700': '#c20a4a',
  '--color-accent-raspberry-800': '#920738',
  '--color-accent-raspberry-900': '#610525',
  '--color-accent-raspberry-950': '#310213',
  '--color-accent-raspberry-1000': '#19010a',
  '--color-accent-sky-blue-50': '#ebf7ff',
  '--color-accent-sky-blue-100': '#d6f2ff',
  '--color-accent-sky-blue-200': '#a2cef5',
  '--color-accent-sky-blue-300': '#89c2f5',
  '--color-accent-sky-blue-400': '#75bfff',
  '--color-accent-sky-blue-500': '#5cb2ff',
  '--color-accent-sky-blue-600': '#2d91eb',
  '--color-accent-sky-blue-700': '#0f84ec',
  '--color-accent-sky-blue-800': '#1170cf',
  '--color-accent-sky-blue-900': '#144b81',
  '--color-accent-sky-blue-950': '#092d51',
  '--color-accent-sky-blue-1000': '#001326',
  '--color-accent-pink-flamingo-50': '#ffe5fa',
  '--color-accent-pink-flamingo-100': '#ffccf6',
  '--color-accent-pink-flamingo-200': '#faaaeb',
  '--color-accent-pink-flamingo-300': '#fa91e6',
  '--color-accent-pink-flamingo-400': '#f576dd',
  '--color-accent-pink-flamingo-500': '#eb5bd0',
  '--color-accent-pink-flamingo-600': '#e043c3',
  '--color-accent-pink-flamingo-700': '#d415b0',
  '--color-accent-pink-flamingo-800': '#b80496',
  '--color-accent-pink-flamingo-900': '#7c0366',
  '--color-accent-pink-flamingo-950': '#4b023d',
  '--color-accent-pink-flamingo-1000': '#190114',
  '--color-accent-persimmon-50': '#fff2eb',
  '--color-accent-persimmon-100': '#ffe1d1',
  '--color-accent-persimmon-200': '#ffc7a8',
  '--color-accent-persimmon-300': '#ffad80',
  '--color-accent-persimmon-400': '#ff8b4d',
  '--color-accent-persimmon-500': '#ff6a1a',
  '--color-accent-persimmon-600': '#e55000',
  '--color-accent-persimmon-700': '#ce5000',
  '--color-accent-persimmon-800': '#993600',
  '--color-accent-persimmon-900': '#662400',
  '--color-accent-persimmon-950': '#331200',
  '--color-accent-persimmon-1000': '#1a0900',
  '--color-accent-maximum-yellow-50': '#fdfeec',
  '--color-accent-maximum-yellow-100': '#fafdd3',
  '--color-accent-maximum-yellow-200': '#f7fca9',
  '--color-accent-maximum-yellow-300': '#ebf28c',
  '--color-accent-maximum-yellow-400': '#e3ed5a',
  '--color-accent-maximum-yellow-500': '#c7d140',
  '--color-accent-maximum-yellow-600': '#8f9408',
  '--color-accent-maximum-yellow-700': '#7b8007',
  '--color-accent-maximum-yellow-800': '#6a6e06',
  '--color-accent-maximum-yellow-900': '#595c05',
  '--color-accent-maximum-yellow-950': '#404203',
  '--color-accent-maximum-yellow-1000': '#171801',
  '--color-accent-rackley-50': '#eef2f6',
  '--color-accent-rackley-100': '#dee4ed',
  '--color-accent-rackley-200': '#c7d1e1',
  '--color-accent-rackley-300': '#acbcd2',
  '--color-accent-rackley-400': '#8ba1c1',
  '--color-accent-rackley-500': '#748eb4',
  '--color-accent-rackley-600': '#5a79a6',
  '--color-accent-rackley-700': '#476085',
  '--color-accent-rackley-800': '#3e5474',
  '--color-accent-rackley-900': '#2d3c53',
  '--color-accent-rackley-950': '#1b2432',
  '--color-accent-rackley-1000': '#090c11',
  '--color-accent-dusty-gray-50': '#f1f1f3',
  '--color-accent-dusty-gray-100': '#e3e3e8',
  '--color-accent-dusty-gray-200': '#d5d5dc',
  '--color-accent-dusty-gray-300': '#c7c7d1',
  '--color-accent-dusty-gray-400': '#abacba',
  '--color-accent-dusty-gray-500': '#8f90a3',
  '--color-accent-dusty-gray-600': '#73748c',
  '--color-accent-dusty-gray-700': '#5c5d70',
  '--color-accent-dusty-gray-800': '#40404e',
  '--color-accent-dusty-gray-900': '#2e2e38',
  '--color-accent-dusty-gray-950': '#1c1c22',
  '--color-accent-dusty-gray-1000': '#0c0c0e',
  '--text-color-highlight': '#036333',
  '--text-color-inverse': '#eef3fc',
  '--text-color-disabled': '#8798b2',
  '--text-color-selected': '#5e53de',
  '--text-color-placeholder': '#5e6e88',
  '--text-color-bold': '#181b25',
  '--text-color-default': '#303c50',
  '--text-color-success': '#02724f',
  '--text-color-warning': '#805500',
  '--text-color-destructive': '#cc0025',
  '--text-color-accent-raspberry': '#610525',
  '--text-color-accent-pink-flamingo': '#7c0366',
  '--text-color-accent-sushi-green': '#2b4912',
  '--text-color-accent-persimmon': '#662400',
  '--text-color-accent-max-yellow': '#595c05',
  '--text-color-accent-rackley': '#2d3c53',
  '--text-color-accent-olive': '#3e3905',
  '--text-color-accent-ai': '#004e52',
  '--text-color-accent-skyblue': '#144b81',
  '--text-color-accent-palatinate-blue': '#081b68',
  '--text-color-accent-vodka': '#2f116e',
  '--text-color-accent-orchid': '#530679',
  '--text-color-accent-royal-fuchsia': '#641b4b',
  '--text-color-link': '#004e7a',
  '--text-color-link-hover': '#0272b1',
  '--text-color-ai-highlight': '#006e68',
  '--text-color-info': '#1170cf',
  '--text-color-contrast': '#181b25',
  '--ring-color-default': '#2d91eb',
  '--ring-color-secondary': '#9c93fb',
  '--bg-color-status-destructive-subtle': '#fff5f6',
  '--bg-color-status-warning-subtle': '#fff6e6',
  '--bg-color-status-success-subtle': '#edfcf6',
  '--bg-color-status-info-subtle': '#ebf7ff',
  '--bg-color-status-inverse': '#0b1525',
  '--bg-color-status-success': '#26cf9f',
  '--bg-color-status-warning': '#ffc042',
  '--bg-color-status-info': '#5cb2ff',
  '--bg-color-status-highlight-subtle': '#ebfef5',
  '--bg-color-status-neutral': '#eef3fc',
  '--bg-color-status-destructive': '#ff5271',
  '--bg-color-status-highlight': '#4dffa6',
  '--bg-color-status-neutral-subtle': '#e5eefa',
  '--bg-color-status-inverse-subtle': '#142643',
  '--bg-color-input-disabled': '#eef3fc',
  '--bg-color-input-hover': '#e5eefa',
  '--bg-color-input-default': '#eef3fc',
  '--bg-color-input-inverse-disabled': '#eef3fc',
  '--bg-color-input-inverse': '#0b1525',
  '--bg-color-input-inverse-hover': '#142643',
  '--bg-color-input-active': '#d4e2f7',
  '--bg-color-input-micro-active': '#b3c7e5',
  '--bg-color-input-micro-hover': '#eef3fc',
  '--bg-color-input-micro': '#b3c7e5',
  '--bg-color-input-micro-disabled': '#eef3fc',
  '--bg-color-input-inverse-active': '#172d4f',
  '--bg-color-interactive-neutral-disabled': '#eef3fc',
  '--bg-color-interactive-neutral-default': '#eef3fc',
  '--bg-color-interactive-neutral-hover': '#e5eefa',
  '--bg-color-interactive-neutral-active': '#d4e2f7',
  '--bg-color-interactive-neutral-focus': '#b3c7e5',
  '--bg-color-interactive-highlight-default': '#101f37',
  '--bg-color-interactive-highlight-hover': '#344156',
  '--bg-color-interactive-highlight-active': '#344156',
  '--bg-color-interactive-highlight-disabled': '#eef3fc',
  '--bg-color-interactive-destructive-default': '#ff3459',
  '--bg-color-interactive-destructive-hover': '#ff5271',
  '--bg-color-interactive-destructive-active': '#ff002e',
  '--bg-color-interactive-destructive-subtle-default': '#fff5f6',
  '--bg-color-interactive-destructive-subtle-hover': '#ffdbe2',
  '--bg-color-interactive-destructive-subtle-active': '#fff5f6',
  '--bg-color-interactive-destructive-disabled': '#eef3fc',
  '--bg-color-interactive-destructive-subtle-disabled': '#eef3fc',
  '--bg-color-interactive-ai-default-start-hover': '#0cc9c0',
  '--bg-color-interactive-ai-default-start': '#15ede2',
  '--bg-color-interactive-ai-default-end': '#29b2ff',
  '--bg-color-interactive-ai-default-end-hover': '#66c8ff',
  '--bg-color-interactive-ai-subtle-start': '#bbfaf7',
  '--bg-color-interactive-ai-subtle-end': '#ccedff',
  '--bg-color-interactive-ai-subtle-start-hover': '#89faf4',
  '--bg-color-interactive-ai-subtle-start-end': '#8fd7ff',
  '--bg-color-interactive-inverse-default': '#101f37',
  '--bg-color-interactive-inverse-hover': '#142643',
  '--bg-color-interactive-inverse-active': '#172d4f',
  '--bg-color-interactive-inverse-disabled': '#eef3fc',
  '--bg-color-surface-content-shell': '#fbfcfe',
  '--bg-color-surface-base': '#f3f6fc',
  '--bg-color-surface-overlay': '#f7f9fd',
  '--bg-color-surface-page-container': '#fbfcfe',
  '--bg-color-surface-floating': '#fbfcfe',
  '--bg-color-surface-ai-end': '#d9fffd',
  '--bg-color-accent-raspberry-subtle': '#fde7ef',
  '--bg-color-accent-raspberry-subtle-hover': '#fdcedf',
  '--bg-color-accent-raspberry-bold': '#f76e9d',
  '--bg-color-accent-pink-flamingo-subtle': '#ffe5fa',
  '--bg-color-accent-pink-flamingo-subtle-hover': '#ffccf6',
  '--bg-color-accent-pink-flamingo-bold': '#f576dd',
  '--bg-color-accent-sushi-green-subtle': '#f1faeb',
  '--bg-color-accent-sushi-green-subtle-hover': '#e4f5d6',
  '--bg-color-accent-sushi-green-bold': '#a0db70',
  '--bg-color-accent-persimmon-subtle': '#fff2eb',
  '--bg-color-accent-persimmon-subtle-hover': '#ffe1d1',
  '--bg-color-accent-persimmon-bold': '#ff8b4d',
  '--bg-color-accent-max-yellow-subtle': '#fdfeec',
  '--bg-color-accent-max-yellow-subtle-hover': '#fafdd3',
  '--bg-color-accent-max-yellow-bold': '#e3ed5a',
  '--bg-color-accent-olive-subtle': '#fdfbe7',
  '--bg-color-accent-olive-subtle-hover': '#fbf8d0',
  '--bg-color-accent-olive-bold': '#e3d212',
  '--bg-color-accent-ai-subtle': '#f0fffe',
  '--bg-color-accent-ai-subtle-hover': '#d9fffd',
  '--bg-color-accent-ai-bold': '#0cc9c0',
  '--bg-color-accent-sky-blue-subtle': '#ebf7ff',
  '--bg-color-accent-sky-blue-subtle-hover': '#d6f2ff',
  '--bg-color-accent-sky-blue-bold': '#75bfff',
  '--bg-color-accent-palatinate-blue-subtle': '#e7ecfd',
  '--bg-color-accent-palatinate-blue-subtle-hover': '#d0d8fb',
  '--bg-color-accent-palatinate-blue-bold': '#5576fa',
  '--bg-color-accent-vodka-subtle': '#efe9fc',
  '--bg-color-accent-vodka-subtle-hover': '#dfd3f8',
  '--bg-color-accent-vodka-bold': '#ae91ee',
  '--bg-color-accent-orchid-subtle': '#f6e7fe',
  '--bg-color-accent-orchid-subtle-hover': '#edcffc',
  '--bg-color-accent-orchid-bold': '#ce7cf7',
  '--bg-color-accent-royal-fuchsia-subtle': '#faebf4',
  '--bg-color-accent-royal-fuchsia-subtle-hover': '#f4d7ea',
  '--bg-color-accent-royal-fuchsia-bold': '#d964b0',
  '--bg-color-accent-rackley-subtle': '#eef2f6',
  '--bg-color-accent-rackley-subtle-hover': '#dee4ed',
  '--bg-color-accent-rackley-bold': '#8ba1c1',
  '--bg-color-accent-dusty-gray-subtle': '#f1f1f3',
  '--bg-color-accent-dusty-gray-subtle-hover': '#e3e3e8',
  '--bg-color-accent-dusty-gray-bold': '#abacba',
  '--color-data-severity-info': '#8f90a3',
  '--color-data-severity-low': '#2d91eb',
  '--color-data-severity-high': '#ff3459',
  '--color-data-severity-critical': '#cc0025',
  '--color-data-severity-mid': '#e59900',
  '--color-data-severity-neutral': '#b3c7e5',
  '--color-data-severity-critical-subtle': '#ffdbe2',
  '--color-data-severity-high-subtle': '#fde7ef',
  '--color-data-severity-mid-subtle': '#fff0d1',
  '--color-data-severity-low-subtle': '#ebf7ff',
  '--color-data-severity-info-subtle': '#f1f1f3',
  '--color-data-categorical-cat-01': '#a60df2',
  '--color-data-categorical-cat-02': '#089e96',
  '--color-data-categorical-cat-03': '#541fc6',
  '--color-data-categorical-cat-04': '#2d91eb',
  '--color-data-categorical-cat-05': '#c33591',
  '--color-data-categorical-cat-06': '#ce5000',
  '--color-data-categorical-cat-07': '#081b68',
  '--color-data-categorical-cat-08': '#554f07',
  '--color-data-categorical-cat-09': '#c20a4a',
  '--color-data-categorical-cat-10': '#a1920c',
  '--color-data-categorical-cat-11': '#3e5474',
  '--color-data-categorical-cat-12': '#662400',
  '--color-data-categorical-cat-other': '#5a79a6',
  '--color-data-categorical-cat-13': '#640891',
  '--color-data-categorical-cat-14': '#842462',
  '--color-data-categorical-cat-15': '#003945',
  '--color-data-node-vodka': '#6e39e0',
  '--color-data-node-turquoise': '#089e96',
  '--color-data-node-sushi-green': '#5b9c27',
  '--color-data-node-sky-blue': '#2d91eb',
  '--color-data-node-royal-fucsia': '#c33591',
  '--color-data-node-persimmon': '#e55000',
  '--color-data-node-palantine-blue': '#1d47f0',
  '--color-data-node-olive': '#a1920c',
  '--color-data-node-raspberry': '#e90c59',
  '--color-data-node-pink-flamingo': '#e043c3',
  '--color-data-node-rackley': '#5a79a6',
  '--color-data-node-orchid': '#a60df2',
  '--color-data-node-maximum-yellow': '#8f9408',
  '--color-data-informative-positive': '#26cf9f',
  '--color-data-informative-informative': '#5cb2ff',
  '--color-data-informative-negative': '#ff5271',
  '--color-data-informative-intermidate': '#ffc042',
  '--color-data-informative-neutral': '#b3c7e5',
  '--color-data-informative-unknown': '#8f90a3',
  '--color-data-sequential-set-1-seq-01': '#edcffc',
  '--color-data-sequential-set-1-seq-02': '#e4b6fb',
  '--color-data-sequential-set-1-seq-03': '#db9efa',
  '--color-data-sequential-set-1-seq-04': '#ce7cf7',
  '--color-data-sequential-set-1-seq-05': '#c44dff',
  '--color-data-sequential-set-1-seq-06': '#a60df2',
  '--color-data-sequential-set-1-seq-07': '#850ac2',
  '--color-data-sequential-set-1-seq-08': '#640891',
  '--color-data-sequential-set-1-seq-09': '#530679',
  '--color-data-sequential-set-1-seq-10': '#28033a',
  '--color-data-sequential-set-2-seq-01': '#d9fffd',
  '--color-data-sequential-set-2-seq-02': '#bbfaf7',
  '--color-data-sequential-set-2-seq-03': '#89faf4',
  '--color-data-sequential-set-2-seq-04': '#15ede2',
  '--color-data-sequential-set-2-seq-05': '#0cc9c0',
  '--color-data-sequential-set-2-seq-06': '#089e96',
  '--color-data-sequential-set-2-seq-07': '#00857e',
  '--color-data-sequential-set-2-seq-08': '#006e68',
  '--color-data-sequential-set-2-seq-09': '#004e52',
  '--color-data-sequential-set-2-seq-10': '#003945',
  '--color-data-sequential-set-3-seq-01': '#d0d8fb',
  '--color-data-sequential-set-3-seq-02': '#a9b9fc',
  '--color-data-sequential-set-3-seq-03': '#7f98fa',
  '--color-data-sequential-set-3-seq-04': '#5576fa',
  '--color-data-sequential-set-3-seq-05': '#4064f5',
  '--color-data-sequential-set-3-seq-06': '#1d47f0',
  '--color-data-sequential-set-3-seq-07': '#0e2eaf',
  '--color-data-sequential-set-3-seq-08': '#0b268f',
  '--color-data-sequential-set-3-seq-09': '#081b68',
  '--color-data-sequential-set-3-seq-10': '#050c39',
  '--color-data-sequential-set-4-seq-01': '#ffccf6',
  '--color-data-sequential-set-4-seq-02': '#faaaeb',
  '--color-data-sequential-set-4-seq-03': '#fa91e6',
  '--color-data-sequential-set-4-seq-04': '#f576dd',
  '--color-data-sequential-set-4-seq-05': '#eb5bd0',
  '--color-data-sequential-set-4-seq-06': '#e043c3',
  '--color-data-sequential-set-4-seq-07': '#d415b0',
  '--color-data-sequential-set-4-seq-08': '#b80496',
  '--color-data-sequential-set-4-seq-09': '#7c0366',
  '--color-data-sequential-set-4-seq-10': '#4b023d',
  '--color-data-diverging-neutral-compare-num-01': '#640891',
  '--color-data-diverging-neutral-compare-num-02': '#850ac2',
  '--color-data-diverging-neutral-compare-num-03': '#a60df2',
  '--color-data-diverging-neutral-compare-num-04': '#c44dff',
  '--color-data-diverging-neutral-compare-num-05': '#ce7cf7',
  '--color-data-diverging-neutral-compare-num-06': '#db9efa',
  '--color-data-diverging-neutral-compare-num-07': '#e4b6fb',
  '--color-data-diverging-neutral-compare-num-08': '#bbfaf7',
  '--color-data-diverging-neutral-compare-num-09': '#89faf4',
  '--color-data-diverging-neutral-compare-num-10': '#15ede2',
  '--color-data-diverging-neutral-compare-num-11': '#0cc9c0',
  '--color-data-diverging-neutral-compare-num-12': '#089e96',
  '--color-data-diverging-neutral-compare-num-13': '#00857e',
  '--color-data-diverging-neutral-compare-num-14': '#006e68',
  '--color-data-diverging-natural-association-num-01': '#cc0025',
  '--color-data-diverging-natural-association-num-02': '#ff002e',
  '--color-data-diverging-natural-association-num-03': '#ff3459',
  '--color-data-diverging-natural-association-num-04': '#ff5271',
  '--color-data-diverging-natural-association-num-05': '#fe8191',
  '--color-data-diverging-natural-association-num-06': '#f5a3b1',
  '--color-data-diverging-natural-association-num-07': '#f8bec9',
  '--color-data-diverging-natural-association-num-08': '#a9b9fc',
  '--color-data-diverging-natural-association-num-09': '#7f98fa',
  '--color-data-diverging-natural-association-num-10': '#5576fa',
  '--color-data-diverging-natural-association-num-11': '#4064f5',
  '--color-data-diverging-natural-association-num-12': '#1d47f0',
  '--color-data-diverging-natural-association-num-13': '#0e2eaf',
  '--color-data-diverging-natural-association-num-14': '#0b268f',
  '--border-color-bold': '#b3c7e5',
  '--border-color-highlight': '#06e073',
  '--border-color-destructive': '#ff002e',
  '--border-color-inverse': '#172130',
  '--border-color-default': '#d4e2f7',
  '--border-color-subtle': '#e5eefa',
  '--border-color-accent-ai-subtle': '#15ede2',
  '--border-color-accent-olive-subtle': '#fbf8d0',
  '--border-color-accent-sushi-green-subtle': '#e4f5d6',
  '--border-color-accent-skyblue-subtle': '#d6f2ff',
  '--border-color-accent-palatinate-blue-subtle': '#d0d8fb',
  '--border-color-accent-vodka-subtle': '#dfd3f8',
  '--border-color-accent-raspberry-subtle': '#fdcedf',
  '--border-color-accent-pink-flamingo-subtle': '#ffccf6',
  '--border-color-accent-royal-fuchsia-subtle': '#f4d7ea',
  '--border-color-accent-orchid-subtle': '#edcffc',
  '--border-color-accent-persimmon-subtle': '#ffe1d1',
  '--border-color-accent-max-yellow-subtle': '#fafdd3',
  '--border-color-accent-rackley-subtle': '#dee4ed',
  '--border-color-disabled': '#e5eefa',
  '--border-color-selected': '#5e53de',
  '--border-color-destructive-hover': '#ff5271',
  '--border-color-warning': '#ffc042',
  '--border-color-info': '#29b2ff',
  '--border-color-success': '#26cf9f',
  '--border-color-destructive-subtle': '#ffdbe2',
} satisfies Record<string, HexColor>;

export const unityRGBATokens: Record<string, string> = {
  '--shadow-color-md': 'rgba(54, 67, 89, 0.2)',
  '--shadow-color-sm': 'rgba(54, 67, 89, 0.2)',
  '--shadow-color-lg': 'rgba(54, 67, 89, 0.15)',
  '--shadow-color-content-shell': 'rgba(54, 67, 89, 0.08)',
  '--bg-color-surface-backdrop': 'rgba(23, 45, 79, 0.15)',
  '--bg-color-surface-ai-start': 'rgba(217, 255, 253, 0)',
  '--bg-color-transparent': 'rgba(255, 255, 255, 0)',
};

export const unityTokens: Record<string, string> = {
  '--transition-timing-function-linear': ' Linear',
  '--transition-timing-function-in-out': 'cubic-bezier(0.83, 0, 0.17, 1)',
  '--transition-timing-function-in': 'cubic-bezier(0.64, 0, 0.78, 0)',
  '--transition-timing-function-out': 'cubic-bezier(0.22, 1, 0.36, 1)',
  '--spacing-0': ' 0px',
  '--spacing-1': ' 4px',
  '--spacing-2': ' 8px',
  '--spacing-3': ' 12px',
  '--spacing-4': ' 16px',
  '--spacing-5': '20px',
  '--spacing-6': '24px',
  '--spacing-7': '28px',
  '--spacing-8': '32px',
  '--spacing-9': '36px',
  '--spacing-10': '40px',
  '--spacing-11': '44px',
  '--spacing-12': '48px',
  '--spacing-14': '56px',
  '--spacing-16': '64px',
  '--spacing-18': '72px',
  '--spacing-20': '80px',
  '--spacing-22': '88px',
  '--spacing-24': '96px',
  '--spacing-32': '128px',
  '--spacing-40': '160px',
  '--spacing-50': '200px',
  '--spacing-64': '256px',
  '--spacing-74': '296px',
  '--spacing-80': '320px',
  '--spacing-100': '400px',
  '--spacing-120': '480px',
  '--spacing-140': '560px',
  '--spacing-160': '640px',
  '--spacing-180': '720px',
  '--spacing-210': '840px',
  '--spacing-256': '1024px',
  '--spacing-320': '1280px',
  '--spacing-360': '1440px',
  '--spacing-480': '1920px',
  '--spacing-0-5': '2px',
  '--spacing-1-5': '6px',
  '--spacing-2-5': '10px',
  '--spacing-px': '1px',
  '--spacing-3-5': '14px',
  '--shadow-offset-y-md': '4px',
  '--shadow-offset-y-sm': '4px',
  '--shadow-offset-y-lg': '-4px',
  '--shadow-offset-y-content-shell': '-16px',
  '--shadow-blur-radius-lg': '40px',
  '--shadow-blur-radius-md': '32px',
  '--shadow-blur-radius-sm': '12px',
  '--shadow-blur-radius-content-shell': '40px',
  '--shadow-offset-x-md': '0px',
  '--shadow-offset-x-lg': '0px',
  '--shadow-offset-x-sm': '0px',
  '--shadow-offset-x-content-shell': '0px',
  '--shadow-spread-radius-sm': '4px',
  '--shadow-spread-radius-md': '8px',
  '--shadow-spread-radius-lg': '0px',
  '--shadow-spread-radius-content-shell': '-16px',
  '--border-radius-sm': '6px',
  '--border-radius-lg': '12px',
  '--border-radius-md': '8px',
  '--border-radius-none': '0px',
  '--border-radius-xs': '4px',
  '--border-radius-full': '1920px',
  '--border-radius-xl': '16px',
  '--ring-width-0': '0px',
  '--ring-width-2': '2px',
  '--font-family-sans': 'Figtree',
  '--font-weight-medium': '500',
  '--font-weight-semibold': '600',
  '--font-weight-bold': '700',
  '--font-weight-light': '300',
  '--font-weight-normal': '400',
  '--font-size-xs': '12px',
  '--font-size-sm': '16px',
  '--font-size-lg': '20px',
  '--font-size-xl': '24px',
  '--font-size-2xl': '28px',
  '--font-size-3xl': '32px',
  '--font-size-4xl': '36px',
  '--font-size-5xl': '48px',
  '--font-size-6xl': '56px',
  '--font-size-7xl': '72px',
  '--font-size-8xl': '96px',
  '--font-size-base': '14px',
  '--font-size-md': '18px',
  '--line-height-xs': '16px',
  '--line-height-base': '20px',
  '--line-height-sm': '24px',
  '--line-height-lg': '28px',
  '--line-height-xl': '32px',
  '--line-height-2xl': '36px',
  '--line-height-3xl': '40px',
  '--line-height-4xl': '48px',
  '--line-height-5xl': '64px',
  '--line-height-6xl': '72px',
  '--line-height-7xl': '96px',
  '--line-height-8xl': '120px',
  '--line-height-md': '24px',
  '--letter-spacing-0': '0px',
  '--letter-spacing-xs': '1px',
  '--letter-spacing-sm': '2px',
  '--letter-spacing-md': '-1px',
};
